//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import DateFnsUtils from "@date-io/date-fns";
import * as moment from "moment";


// custom pages
import { styles } from "./styles";
import response from "apis/Response/response"
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import IconButton from "@material-ui/core/IconButton";

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Fragment } from "react";

//Helpers
import {dateFormat} from "helpers/dataFormat"

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function View(props) {
  const { state, dispatch } = useContext(Context);
  const { updateResponse } = response();
  const history = useHistory();
  const location = useLocation();
  const classes = styles();
  ;
  const [states, setstates] = useState({
    statusCode: "",
    type: "",
    message:"",
    keyword:"",
    data: {},
    edittedData: {},
    isEdit: false,
    loading: false,
  });

  const {
    statusCode,
    type,
    message,
    keyword,
    data,
    edittedData,
    isEdit,
    loading,
  } = states;

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    console.log(location,"reslo")
    if (location?.state?.data) {
      let dataObj = location?.state?.data;
      setDataObj(dataObj);
    }
  }, []);

  const setDataObj = (dataObj) => {
    setStates({
      data: dataObj,
      statusCode: dataObj?.status_code,
      type: dataObj?.type,
      message: dataObj?.message,
      keyword: dataObj?.keyword,
    });
  };

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "RESPONSE", "VIEW"],
    });
  }, []);
  
  const handleUpdateResponse = async () => {
    try {
      if (Object.keys(edittedData).length === 0) {
        toast.error("Please alter atleast one field.", {
          toastId: "update-error",
        });
        setStates({ loading: false });
        return;
      }
      let failed = false;
      Object.keys(edittedData).map((o) => {
        if (!edittedData[o] && typeof edittedData[o] != "boolean") {
          failed = true;
        }
      });
      if (failed) {
        toast.error("Cannot update empty field.", {
          toastId: "update-error-2",
        });
        setStates({ loading: false });
        return;
      }

      let values;
      values = {
        ...edittedData,
        statusCode: data?.statusCode,
        keyword: data?.keyword
      };
      
      let res = await updateResponse(values);
      if (res?.data === 1) {
        toast.success("Updated", { toastId: "rule-updated" });
        history.goBack();
      }
      setStates({ loading: false });
    } 
    catch (e) {
      console.log({ e });
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <IconButton
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon style={{ color: "#305698" }} />
          </IconButton>
          {/* <span style={{ fontSize: 18 }}>
            <strong> {t('statusCode')} :</strong> {data?.status_code}
          </span> */}
          <span style={{ fontSize: 18 }}>
            <strong> {'keyword'} :</strong> {data?.keyword}
          </span>
          {!isEdit && (
            <Button
              className={`${classes.createBtn} dash-1-filter-btn`}
              onClick={() => {
                setStates({ isEdit: true });
              }}
            >
              {'Edit'}
            </Button>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={4} style={{ padding: 10, fontSize: 16 }}>
      <Grid item xs={8}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{'Status Code'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={statusCode}
                    onChange={(e) => {
                      setStates({
                        statusCode: e.target.value,
                        edittedData: {
                          ...edittedData,
                          statusCode: e.target.value,
                        },
                      });
                    }}
                  />
                ) : <span className={classes.label}>{statusCode}</span>
              }
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={8}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{'Type'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={type}
                    onChange={(e) => {
                      setStates({
                        type: e.target.value,
                        edittedData: {
                          ...edittedData,
                          type: e.target.value,
                        },
                      });
                    }}
                  />
                ) : <span className={classes.label}>{type}</span>
              }
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item xs={8}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{t('keyword')} : </strong>
            </Grid>
            <Grid item xs={8}>
              {                
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={keyword}
                    onChange={(e) => {
                      setStates({
                        keyword: e.target.value,
                        edittedData: {
                          ...edittedData,
                          keyword: e.target.value,
                        },
                      });
                    }}
                  />
                ) : <span className={classes.label}>{keyword}</span>
              }
            </Grid>
          </Grid>
        </Grid> */}
        <Grid item xs={8}>
          <Grid container spacing={0}>
            <Grid item xs={4}>
              <strong className={classes.label}>{'message'} : </strong>
            </Grid>
            <Grid item xs={8}>
              {                
                isEdit ? (
                  <CssTextField
                    variant="outlined"
                    type={"text"}
                    required
                    className={classes.editInput}
                    value={message}
                    onChange={(e) => {
                      setStates({
                        message: e.target.value,
                        edittedData: {
                          ...edittedData,
                          message: e.target.value,
                        },
                      });
                    }}
                  />
                ) : <span className={classes.label}>{message}</span>
              }
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={0} style={{ padding: 10 }}>
        <Grid item xs={12} style={{ textAlign: "right" }}>
          {
            isEdit && (
              <Fragment>
                <Button
                  className={classes.cancelBtn}
                  onClick={() => {
                    setDataObj(data);
                    setStates({ isEdit: false, edittedData: {} });
                  }}
                >
                  {'Cancel'}
                </Button>
                &nbsp; &nbsp; &nbsp;
                <Button
                  className={classes.submitBtn}
                  onClick={() => {
                    setStates({ loading: true });
                    handleUpdateResponse();
                  }}
                  disabled={loading}
                >
                  {'Update'}
                </Button>
              </Fragment>
            )
          }
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
